import * as React from 'react';
import classNames from 'classnames';
import styles from './LoadingBar.module.scss';

export interface LoadingBarProps {
	readonly className?: string;
	readonly width?: string;
	readonly height?: string;
}

/**
 * Generic LoadingBar component, used in skeleton components to be shown while data loading
 */
export const LoadingBar: React.FunctionComponent<LoadingBarProps> = ({ width, height, className }) => {
	return (
		<span
			className={classNames(styles.skeleton, className)}
			style={{ '--width': width || undefined, '--height': height || undefined } as React.CSSProperties}
		/>
	);
};
